import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, OnInit, signal } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router, RouterLink } from '@angular/router';
import { Intercom, shutdown } from '@intercom/messenger-js-sdk';
import { AuthAppService } from 'avn/modules/services/auth-app/auth-app.service';
import { Auth0UiService } from 'avn/modules/services/auth0-serv.service';
import { Constants } from 'avn/modules/services/constants';
import { StoreService } from 'avn/modules/services/store.service';

@Component({
  selector: 'app-mega-menu-mobile',
  templateUrl: './mega-menu-mobile.html',
  styleUrls: ['./mega-menu-mobile.scss'],
  imports: [RouterLink],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MegaMenuMobileComponent implements OnInit {
  public readonly selectedMain = signal<'wellbeing' | 'others' | ''>('');
  public readonly selectedGroup = signal<
    'Physical' | 'Mental' | 'Natural' | 'Fitness' | 'Online Services' | 'Health Conditions' | ''
  >('');
  public readonly selectedService = signal<any>(undefined);

  public hasBusiness = false;
  public isWellbeingOwner = false;

  public headerCategories: any = {};
  public healthConditionList: any[] = [];
  public readonly workcoverLoggedUser = signal<any>(undefined);
  public hmacHash = '';
  public name = 'Anonymous User';
  public platform = Constants.APP_NAME;

  public constructor(
    private readonly dialogRef: MatDialogRef<MegaMenuMobileComponent>,
    @Inject(MAT_DIALOG_DATA) private readonly data: any,
    private readonly store: StoreService,
    private readonly router: Router,
    private readonly auth: AuthAppService,
    private readonly auth0: Auth0UiService,
    private readonly cdr: ChangeDetectorRef
  ) {}

  public ngOnInit(): void {
    this.auth.workcoverLoggedUser.subscribe((user) => {
      this.workcoverLoggedUser.set(user);
      this.hasBusiness = user?.businesses?.length > 0 || false;
      this.isWellbeingOwner = user?.is_wellbeing_owner || false;
      this.cdr.markForCheck();
    });
  }

  public fetchBusinessRouting(): string[] {
    const businesses = this.workcoverLoggedUser().businesses;
    const businessId = businesses[0].uuid;

    return ['/business/' + String(businessId)];
  }

  public closeModal(): void {
    this.dialogRef.close();
  }

  public goBackFromGroups(): void {
    this.selectedGroup.set('');
    if (this.selectedMain() === 'others') {
      this.selectedMain.set('');
    }
  }

  public goToServicePage(service: any, suburb: any): void {
    const url = `/search/${String(service.slug)}/${String(suburb.slug)}`;
    this.router.navigate([url]);
    this.closeModal();
  }

  public goToCategoryPage(service: any, suburb?: any): void {
    let url = `/category/${String(service.slug)}`;
    if (suburb) {
      url += `/${String(suburb.slug)}`;
    }
    this.router.navigate([url]);
    this.closeModal();
  }

  public goToHealthConditionPage(service: any, suburb: any): void {
    const url = `/${String(service.name.toLowerCase().replace(/ /g, '-'))}/${String(
      suburb.city.toLowerCase().replace(/ /g, '-')
    )}/${String(suburb.post_code)}`;
    this.router.navigate([url]);
    this.closeModal();
  }

  public selectService(item: any): void {
    if (this.selectedGroup() !== 'Online Services') {
      this.selectedService.set(item);
      return;
    }
    this.router.navigate([`/online/${String(item.slug)}`]);
    this.closeModal();
  }

  public signOut(): void {
    shutdown();
    this.auth0.signOut();
    this.inItIntercom();
  }

  public inItIntercom(): void {
    // For anonymous users after sign out - no email, let Intercom automation ask for it
    Intercom({
      app_id: Constants.INTERCOM_CONFIG.appId,
      user_name: `Anonymous ${this.platform} User`,
      platform: this.platform
    });
  }
}
